<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getCity } from "@/api/system/city";
import { getWarehouse } from "@/api/storage/warehouse";
// import { getClient } from "@/api/user/client";
// import { getSku } from "@/api/storage/sku";
import { getGoods, getDetails, goodsUp, goodsDown } from "@/api/storage/good";
import cTable from "@/base/common/index";
export default {
  name: "goods",
  components: {
    cTable
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "warehouse_id")
        item.options = (await getWarehouse()).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: getGoods
        // getDetails
      },
      config: {
        height: 630,
      },
      footer:{
        pageSize: [15, 100, 500, 1000, 5000,20000],
      },
      modals: {
        add: {
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true
            }
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("barCode"),
                key: "bar_code"
              },
              {
                name: () => this.$t("skuName"),
                key: "sku_name"
              },
              {
                name: () => this.$t("doublePrice"),
                key: "declaration_amount"
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: 'salesman_id',
            placeholder() {
              return this.$tz('业务员')
            },
            component: 'Select',
            options: [],
            optionsFn: 'salesman',
            optionsKey: '',
          },
          {
            key: 'client_id',
            placeholder() {
              return this.$tz('客户名称')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getAllClient',
            optionsKey: '',
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_title",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t('businessUser'),
          key: 'sale_name',
          minWidth: 110,
        },
        {
          name: () => this.$tz('公司中文名'),
          key: 'company',
          minWidth: 110,
        },
        {
          name: () => this.$t("skuName1"),
          key: "sku_name",
          align: "left",
          minWidth: 100,
          slot: "TEST"
        },
        {
          name: () => this.$t("skuTitle"),
          key: "sku_title",
          align: "left",
          tooltip: true,
          minWidth: 125
        },
        {
          name: () => this.$t("SKU Barcode"),
          key: "bar_code",
          align: "left",
          minWidth: 100
        },
				{
				  name: () => this.$t("Weight"),
				  key: "weight",
				  minWidth: 100
				},
				{
				  name: () => this.$t("skuVolume"),
				  key: "volume",
				  minWidth: 100
				},
				{
				  name: () => this.$t("length"),
				  key: "length",
				  minWidth: 100
				},
				{
				  name: () => this.$t("width"),
				  key: "width",
				  minWidth: 100
				},
				{
				  name: () => this.$t("height"),
				  key: "height",
				  minWidth: 100
				},
        {
          name: () => this.$t("location"),
          key: "location",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("order_goods1"),
          key: "quantity",
          align: "center",
          minWidth: 100
        }
      ]
    };
  }
};
</script>
